'use client';

import { useEffect } from 'react';
import { useRouter } from '@/i18n/navigation';
import { useLocale } from 'next-intl';
import { useTheme } from 'next-themes';

export default function DemoPage() {
  const router = useRouter();
  const locale = useLocale();
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const onMsg = (e: MessageEvent) => {
      const m = e.data as { type?: string; surface?: string };
      if (m?.type !== 'lb-nav') return;
      if (m.surface === 'auth') router.push('/signup');
      else if (m.surface === 'marketing') router.push('/');
    };
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, [router]);

  const theme = resolvedTheme === 'dark' ? 'dark' : 'light';

  return (
    <iframe
      src={`/demo-static/index.html?locale=${locale}&theme=${theme}`}
      className="fixed inset-0 w-full h-full border-0"
      title="Lithosbase Demo guidata"
      allow="fullscreen"
    />
  );
}
